import { type MCPServerInfo } from '../../types';

const AmplitudeServer: MCPServerInfo = {
  serverId: 'AMPLITUDE',
  name: 'Amplitude',
  slug: 'amplitude',
  description:
    'Query and create Amplitude analytics content — charts, dashboards, experiments, cohorts, and more — using natural language via the Model Context Protocol.',
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://mcp.amplitude.com/mcp',
    transport: 'STREAMABLE_HTTP'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  }
};

export default AmplitudeServer;
